import { setKidsModeType } from './action-types';

export function setKidsMode(isKidsMode) {
	return {
		type: setKidsModeType,
		isKidsMode,
	};
}
